<template>
    <div class="main">
        <nav :class="this.isScrolled ? 'navbar navbarScrolled' : 'navbar'">
            <RouterLink class="logoArea" to="/">
                <img class="logo" v-if="!isScrolled" src="../assets/navbar/nav_logo.webp" alt="">
                <img class="logo" v-else src="../assets/navbar/nav_logo_scrolled.webp" alt="">
            </RouterLink>
            <div class="menuWrap desktop-only">
                <RouterLink to="/" :class="this.selectedPage == 0 ? menuItemSelectedClass : menuItemClass" @click="changeSelectedPage(0)">HOME</RouterLink>
                <RouterLink to="/about" :class="this.selectedPage == 1 ? menuItemSelectedClass : menuItemClass" @click="changeSelectedPage(1)">ABOUT US</RouterLink>
                <RouterLink to="/products/healthcare" :class="this.selectedPage == 2 ? menuItemSelectedClass : menuItemClass"  @click="changeSelectedPage(2)">PRODUCTS</RouterLink>
                <RouterLink to="/markets" :class="this.selectedPage == 3 ? menuItemSelectedClass : menuItemClass" @click="changeSelectedPage(3)">MARKETS</RouterLink>
                <RouterLink to="/contact" :class="this.selectedPage == 4 ? menuItemSelectedClass : menuItemClass" @click="changeSelectedPage(4)">CONTACT</RouterLink>
            </div>

            <div class="mobile-menu-btn mobile-only" @click="toggleMobileMenu">
                <div :class="['hamburger', { 'is-active': mobileMenuOpen }]">
                    <span class="line" :class="{'scrolled': isScrolled && !mobileMenuOpen}"></span>
                    <span class="line" :class="{'scrolled': isScrolled && !mobileMenuOpen}"></span>
                    <span class="line" :class="{'scrolled': isScrolled && !mobileMenuOpen}"></span>
                </div>
            </div>

            <div class="mobile-menu-overlay mobile-only" :class="{ 'is-open': mobileMenuOpen }" @click="toggleMobileMenu"></div>

            <div :class="['mobile-menu', { 'is-open': mobileMenuOpen }]">
                 <RouterLink to="/" :class="this.selectedPage == 0 ? 'mobileMenuItemSelected' : 'mobileMenuItem'" @click="changeSelectedPage(0); toggleMobileMenu()">HOME</RouterLink>
                <RouterLink to="/about" :class="this.selectedPage == 1 ? 'mobileMenuItemSelected' : 'mobileMenuItem'" @click="changeSelectedPage(1); toggleMobileMenu()">ABOUT US</RouterLink>
                <RouterLink to="/products/healthcare" :class="this.selectedPage == 2 ? 'mobileMenuItemSelected' : 'mobileMenuItem'"  @click="changeSelectedPage(2); toggleMobileMenu()">PRODUCTS</RouterLink>
                <RouterLink to="/markets" :class="this.selectedPage == 3 ? 'mobileMenuItemSelected' : 'mobileMenuItem'" @click="changeSelectedPage(3); toggleMobileMenu()">MARKETS</RouterLink>
                <RouterLink to="/contact" :class="this.selectedPage == 4 ? 'mobileMenuItemSelected' : 'mobileMenuItem'" @click="changeSelectedPage(4); toggleMobileMenu()">CONTACT</RouterLink>
            </div>
        </nav>
        <div v-if="this.showdash" class="split_dash"></div>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            isScrolled: false,
            selectedPage: 0,
            showdash: false,
            mobileMenuOpen: false,
            routeDict: {
                "/": 0,
                "/about": 1,
                "/products": 2,
                "/markets": 3,
                "/contact": 4,
            }
        }
    },

    computed: {
        menuItemClass() {
            if (this.isScrolled) {
                return 'menuItemScrolled'
            }
            else {
                return 'menuItem'
            }
        },

        menuItemSelectedClass() {
            if (this.isScrolled) {
                return 'menuItemScrolled menuItemScrolledSelected'
            }
            else {
                return 'menuItem menuItemSelected'
            }
        }
    },

    methods: {
        changeSelectedPage(index) {
            this.selectedPage = index
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen
        }
    },

    mounted() {
        var that = this
        this.$watch(
            () => this.$route.path,
            (newPath) => {
                var flag = newPath.match(/^\/[^/]*/g)[0]
                that.selectedPage = that.routeDict[flag]
                if (flag == "/products") {
                    that.showdash = true
                }
                else {
                    that.showdash = false
                }
            }
        )
        window.addEventListener('scroll', function() {
            // console.log("aaa:" + that.$refs.navbar.isScrolled)
            if (window.$(document).scrollTop() >= 5) {
                that.isScrolled = true
                // console.log("window.$(document).scrollTop:"+window.$(document).scrollTop())
            }
            else {
                that.isScrolled = false
            }
        })
    },
}
</script>

<style scoped lang="scss">
.main {
    display: flex;
    flex-direction: column;
    
    width: 100%;
    align-items: center;

    .navbar {
        width: 100%;
        padding: 0 $screenPadding;
        height: calc($navBarHeight + 1px);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        // position: relative;
        // margin: 0 $screenPadding;
        // border-bottom: 1px solid #D8D8D8;
        // background-color: #eeeeee;

        .logoArea {
            height: 50%;

            .logo {
                height:100%;
                width: auto;
            }
        }

        

        .menuWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 70%;
            justify-content: space-between;

            .menuItem {
                cursor: pointer;
                padding: 0.7rem 2.5rem;
                white-space: nowrap;
                font-size: 1.3rem;
                font-family: "Montserrat", serif;
                font-weight: 600;
                border-radius: 0.5rem;
                // background-color: $mainColor;
                color: #2C2B2B;
                text-decoration: none;
                &:hover {
                    color: $mainColor;
                }
            }

            .menuItemSelected {
                background-color: $mainColor;
                color: #FFFFFF;
                &:hover {
                    // color: #2C2B2B;
                    color: #FFFFFF;
                }
            }

            .menuItemScrolled {
                cursor: pointer;
                padding: 0.7rem 2.5rem;
                white-space: nowrap;
                font-size: 1.3rem;
                font-family: "Montserrat", serif;
                font-weight: 600;
                border-radius: 0.5rem;
                color: #FFFFFF;
                text-decoration: none;
                &:hover {
                    color: #2C2B2B;
                }
            }

            .menuItemScrolledSelected {
                background-color: #FFFFFF;
                color: $mainColor;
                &:hover {
                    // color: #2C2B2B;
                    color: $mainColor;
                }
            }


        }
    }

    .navbarScrolled {
        background-color: $mainColor;
    }

    .split_dash{
        width: 70%;
        height: 1px;
        background-color: #D8D8D8;
    }

    .mobile-only {
        display: none;
    }

    .mobile-menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 98;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s ease-in-out;

        &.is-open {
            opacity: 1;
            visibility: visible;
        }
    }

    .mobile-menu {
        position: fixed;
        top: 0;
        right: 0;
        left: auto;
        width: 70%;
        height: 100vh;
        background-color: #FFFFFF;
        z-index: 99;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transform: translateX(100%);
        transition: transform 0.3s ease-in-out;
        box-shadow: -2px 0 5px rgba(0,0,0,0.1);
        
        &.is-open {
            transform: translateX(0);
        }

        .mobileMenuItem {
            font-size: 1rem;
            margin: 1.2rem 0;
            color: #2C2B2B;
            text-decoration: none;
            font-family: "Montserrat", serif;
            font-weight: 600;
        }

        .mobileMenuItemSelected {
            font-size: 1rem;
            margin: 1.2rem 0;
            color: $mainColor;
            text-decoration: none;
            font-family: "Montserrat", serif;
            font-weight: 600;
        }
    }

    .mobile-menu-btn {
        z-index: 100;
        cursor: pointer;
        
        .hamburger {
            width: 30px;
            height: 24px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            
            .line {
                width: 100%;
                height: 3px;
                background-color: #2C2B2B;
                transition: all 0.3s ease;
                border-radius: 3px;

                &.scrolled {
                    background-color: #FFFFFF;
                }
            }

            &.is-active {
                .line:nth-child(1) {
                    transform: translateY(10.5px) rotate(45deg);
                    background-color: #2C2B2B;
                }
                .line:nth-child(2) {
                    opacity: 0;
                }
                .line:nth-child(3) {
                    transform: translateY(-10.5px) rotate(-45deg);
                    background-color: #2C2B2B;
                }
            }
        }
    }

    @media (max-width: 768px) {
        .navbar {
            padding: 0 1.5rem;
            height: 4rem; 
        }
        
        .desktop-only {
            display: none !important;
        }

        .mobile-only {
            display: block;
        }

        .split_dash {
            display: none;
        }
    }
}
</style>